<template>
  <div ref="view" class="goods-vip-forever">
    <!--  头部图片  -->
    <div class="bg"><img class="img-content" src="https://img-cdn1.ylyk.com/image/1634105382368_m1634105337203_s88108.jpg" alt=""></div>
    <!-- 无限卡 价格、往期购买列表 -->
    <div ref="card" class="card">
        <div class="card-bg">
          <img width="100%" src="https://img-cdn1.ylyk.com/image/1634105382368_m1634108811350_s155606.jpg" alt="">
          <div class="price-warp">
            <span class="price-unit">无限卡：￥</span> <span class="price-value">{{ salePrice }}</span>
            <img class="icon-price-discounts" v-if="discountTotal > 0"
                 src="../../../images/goods-vip-forever/icon-price-discounts-makeup.png" alt="">
          </div>
          <div class="card-des">享有2021年12月31日前 既有专辑永久畅听权益</div>
          <div class="card-info">
            抵扣往期学费，补差价即可升级<br/>还可免息分期，首付900元
          </div>
        </div>
      <div class="card-equity-info">
        <div v-if="discountTotal > 0">*已抵扣历史消费金额共{{ discountTotal }}元</div>
        <img class="btn_check" @click="detailView('goods-order-list')" src="https://img-cdn1.ylyk.com/image/1634032743673_m1634032652246_s9403.jpg" alt="">
      </div>
    </div>
    <!-- 无限卡权益 -->
    <div class="vip-forever">
      <div class="vip-forever-header"></div>
      <div><img class="goods-new-course" src="https://img-cdn1.ylyk.com/image/1635064949747_m1635063353463_s69910.jpg" alt=""></div>
    </div>
    <!-- 课程表   -->
    <div class="class-schedule">
        <img class="img-content" src="https://img-cdn1.ylyk.com/image/1634032743673_m1634032525058_s20160.jpg" alt=""/>
        <div class="schedule" v-for="(item, index) in schedule" :key="index">
          <img class="img-content" :src="item" alt=""/>
          <img class="check-all" src="https://img-cdn1.ylyk.com/image/1634032743673_m1634032621530_s8761.jpg" @click="detailView('full-course', true, index)" alt=""/>
        </div>
    </div>
    <!--  视频介绍  -->
    <div class="video-wrap">
      <img class="img-content" src="https://img-cdn1.ylyk.com/image/1634105382368_m1634105322316_s26683.jpg" alt=""/>
      <video class="video"  controls webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow"  src="https://mv-cdn1.ylyk.com/media/1634641750679_m1634641660054_s26175688.mp4" poster="https://img-cdn1.ylyk.com/image/1634634535987_m1634634576959_s117764.jpg"></video>
      <img class="img-content" src="https://img-cdn1.ylyk.com/image/1634696153047_m1634696030848_s18217.jpg" alt=""/>
    </div>
    <!-- 实物礼包   -->
    <div class="gift-wrap">
      <img width="100%" src="https://img-cdn1.ylyk.com/image/1634032743673_m1634032495411_s18014.jpg" alt=""/>
      <div v-for="(item, index) in gift" :key="index">
        <div class="gift-swipe">
          <div class="gift-button-left" @click="onPre(index)"><img class="arrow" src="https://img-cdn1.ylyk.com/image/1634032743673_m1634032256388_s1498.jpg" alt=""/></div>
          <Swipe class="swipe-wrap" :auto="0" ref="swipe" :show-indicators="false">
            <SwipeItem class="swipe-item" v-for="(pic, index) in item.content" :key="index"><img width="100%" :src="pic" alt=""></SwipeItem>
          </Swipe>
          <div class="gift-button-right" @click="onNext(index)"><img class="arrow" src="https://img-cdn1.ylyk.com/image/1634032743673_m1634032256385_s1466.jpg" alt=""/></div>
        </div>
        <img class="img-content" :src="item.title" alt="">
      </div>
    </div>
    <!--  购买须知  -->
    <div>
       <img width="100%" src="https://img-cdn1.ylyk.com/image/1634698965176_m1634698939270_s60995.jpg" alt=""/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toFixedFloat } from '@/utils'
import { Swipe, SwipeItem } from 'mint-ui'

export default {
  name: 'goods-vip-forever2021',
  components: { Swipe, SwipeItem },
  props: {
    goods: { type: Object, default: () => {} }
  },
  data() {
    return {
      form: {
        protocol: 0
      },
      schedule: ['https://img-cdn1.ylyk.com/image/1634032743673_m1634032525277_s140282.jpg',
        'https://img-cdn1.ylyk.com/image/1634032743673_m1634032525251_s82053.jpg'],
      gift: [
        { title: 'https://img-cdn1.ylyk.com/image/1634287796363_m1634287728036_s18521.jpg',
          content: [
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954556000_s41486.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954576000_s51409.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954576000_s28622.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954576000_s25182.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954576000_s26134.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954556000_s27229.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954556000_s31008.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634967635598_s51973.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954556000_s56101.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954556000_s38446.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634974246975_s42426.jpg'
          ] },
        { title: 'https://img-cdn1.ylyk.com/image/1634287796363_m1634287728043_s20434.jpg',
          content: [
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954576000_s34262.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954576000_s51409.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954576000_s28622.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954556000_s27229.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634967635598_s51973.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954556000_s56101.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634954556000_s38446.jpg',
            'https://img-cdn1.ylyk.com/image/1634968006136_m1634974246976_s32664.jpg'
          ] }]
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'disCountOrderList'
    ]),
    discountList() {
      return this.disCountOrderList || []
      // return []
    },
    discountTotal() {
      const total = this.disCountOrderList.discountTotal
      return toFixedFloat(total, 2)
    },
    salePrice() {
      let salePrice = this.goods.salePrice - this.discountTotal
      salePrice = salePrice < 0 ? 0 : toFixedFloat(salePrice, 2)
      return salePrice
    }
  },
  methods: {
    onPre(index) {
      console.log('$refs', this.$refs.swipe)
      this.$refs.swipe[index].prev();
    },
    onNext(index) {
      this.$refs.swipe[index].next();
    },
    toggleValue(name) {
      const value = this.form[name]
      this.form[name] = value ? 0 : 1
    },
    // 查看页面
    detailView(name, hasParam, index) {
      if (hasParam) {
        this.$router.push({ name: name, query: { index: index }})
      } else {
        if (!this.$parent.hasUser()) {
          return
        }
        this.$router.push({ name })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.img-content{
  width: 100%;
  display: block;
}
.goods-vip-forever {
  &::-webkit-scrollbar{
    display: none;
    background-color:transparent;
  }
  background-color: #00306A;
  position: relative;
  height: 100%;
  display: flex;
  padding-bottom: .6rem;
  flex-direction: column;
  .card {
    position: relative;
    .card-bg{
      position: relative;
      padding-left: .28rem;
      padding-right: .28rem;
      .price-warp{
        position: absolute;
        top: .36rem;
        left: .98rem;
        display: flex;
        justify-content: center;
        align-items: center;
        height: .84rem;
        .price-unit{
          text-align: left;
          color: #002a58;
          font-size: .32rem;
          line-height: .44rem;
        }
        .price-value{
          font-weight: 600;
          text-align: left;
          color: #002a58;
          font-size: .6rem;
          line-height: .84rem;
        }
        .icon-price-discounts{
          width: 1.04rem;
          height: .4rem;
          margin-bottom: .44rem;
          margin-left: .12rem;
        }
      }
      .card-des{
        position: absolute;
        width: 100%;
        top: 1.46rem;
        right: 0;
        left: 0;
        font-size: .28rem;
        font-weight: 600;
        text-align: center;
        color: #002a58;
      }
      .card-info{
        position: absolute;
        bottom: .66rem;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: .24rem;
        text-align: center;
        line-height: .34rem;
        color: #002a58;
      }
    }
    .card-equity-info{
      width: 100%;
      color: white;
      font-size: .28rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-top: .48rem;
      .btn_check{
        width: 2.68rem;
        height: .66rem;
        margin-top: .24rem;
      }
    }
  }
  .class-schedule{
    .schedule{
      position: relative;
    }
    .check-all{
      position: absolute;
      width: 3.12rem;
      height: .8rem;
      text-align: center;
      bottom: 1.3rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .video-wrap{
    background-color: #022351;
    margin-left: .32rem;
    margin-right: .32rem;
    padding: .32rem;
    border-radius: .16rem;
    .video{
      width: 100%;
    }
  }
  .gift-wrap{
    background-color: #031E47;
    margin-left: .32rem;
    margin-right: .32rem;
    margin-top: .62rem;
    padding-top: .28rem;
    padding-bottom: .28rem;
    border-radius: .16rem;
    .gift-swipe{
      width: 100%;
      height: 3.2rem;
      display: flex;
      flex-flow: row;
      .gift-button-left{
        width: .98rem;
        background: white linear-gradient(270deg,rgba(3, 30, 71, 0.3), rgba(3, 30, 71, 1));
        margin-right: .04rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .gift-button-right{
        width: .98rem;
        background: white linear-gradient(270deg, rgba(3, 30, 71, 1), rgba(3, 30, 71, 0.3));
        margin-left: .04rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .arrow{
        width: .34rem;
        height: .60rem;
      }
      .swipe-wrap{
        width: 100%;
        height: 3.2rem;
        .swipe-item{
          height: 3.2rem;
        }
      }
    }
    ul {
      display: flex;
      width: auto;
      height: 100%;
      overflow-x: auto;
      white-space: nowrap;
      padding: 0;
      margin: 0;
    }
    ul::-webkit-scrollbar {
      display: none;
    }
    li:first-child{
      margin-left: .48rem;
    }
    .gift-img{
      width: 2.4rem;
      height: 3.08rem;
      margin-right: .48rem;
    }
  }
  .vip-forever {
    margin-top: 1rem;
    .vip-forever{
      background: #00306a;
      height: .96rem;
      width: 100%;
    }
    .goods-new-course {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}
</style>
